
<!-- TemplateBeginEditable name="hero" -->
<div class="dcf-hero dcf-hero-default">
  <!-- TemplateEndEditable -->
  <div class="dcf-hero-group-1">
    <div class="dcf-breadcrumbs-wrapper">
      <nav class="dcf-breadcrumbs" id="dcf-breadcrumbs" role="navigation" aria-label="breadcrumbs">
        <!-- TemplateBeginEditable name="breadcrumbs" -->
        <ol>
          <li><a href="https://www.unl.edu/">Nebraska</a></li>
          <li><a href="/">TCAN / VITA Lincoln</a></li>
          <li><span aria-current="page">Cancel/Reschedule</span></li>
        </ol>
        <!-- TemplateEndEditable -->
      </nav>
    </div>
    <header class="dcf-page-title" id="dcf-page-title">
      <!-- TemplateBeginEditable name="pagetitle" -->
      <h1>Cancel/Reschedule Appointment</h1>
      <!-- TemplateEndEditable -->
    </header>
    <!-- TemplateBeginEditable name="herogroup1" -->
    <!-- TemplateEndEditable -->
  </div>
  <!-- TemplateBeginEditable name="herogroup2" -->
  <div class="dcf-hero-group-2">
  </div>
  <!-- TemplateEndEditable -->
</div>
<div class="dcf-main-content dcf-wrapper">
  <!-- TemplateBeginEditable name="maincontentarea" -->
  <div class="dcf-bleed">
    <div class="dcf-wrapper dcf-pb-8">
      <p><b>To cancel or reschedule a previously scheduled appointment, you must find your
        confirmation email titled "VITA Appointment Confirmation".</b> At the bottom of the email,
        under the bolded title "Rescheduling or Cancelling your Appointment", you will find a link
        to reschedule or cancel your appointment.<b> There is no other way to reschedule or cancel an appointment.</b>
        <br><br>
        If you have any questions, please contact vita&#64;unl.edu.
      </p>
    </div>
  </div>
  <!-- TemplateEndEditable -->
</div>